export default __webpack_public_path__ + "static/media/News_w.7bc1c28e.svg";